export default __webpack_public_path__ + "static/media/cunning.47dd9f0a.png";